var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8125 2.81018C1.21094 3.80706 0.71875 4.95002 0.71875 6.01565C0.71875 6.97292 1.06445 7.89097 1.67981 8.56786C2.29516 9.24475 3.12976 9.62502 4 9.62502C4.87024 9.62502 5.70484 9.24475 6.32019 8.56786C6.93555 7.89097 7.28125 6.97292 7.28125 6.01565C7.28125 3.78127 5.875 2.06252 4.73438 0.812134L3.375 3.95315L1.8125 2.81018Z",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/Fire.25e7ae595f722a4e5daeafdd2bbdee99.svg";
export { ForwardRef as ReactComponent };